import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useEffect, useRef, useState } from 'react';
import { getCodigoCab } from '../../services/Roles/RolesService';

const CreaCab = ({ tipo, onGuardar }) => {
    const [nombre, setNombre] = useState('');
    const [codigoCab, setCodigoCab] = useState('');
    const [parametro, setParametro] = useState('');

    const [procesaGuardar, setProcesaGuardar] = useState(false);

    useEffect(() => {
        const recuperaCodigo = async (codTipo, codigoIni) => {
            try {
                const nuevoCod = await getCodigoCab(codTipo, codigoIni);
                //console.log ('BB=', nuevoCod)
                setCodigoCab(nuevoCod);
            } catch (err) {
                console.error(err.message);
            }
        };
        //console.log ('jj0=', tipo.configuracionTipoId , ' *** ', tipo.codigo)
        recuperaCodigo(tipo.configuracionTipoId, tipo.codigo);
    }, []);

    const toastCab = useRef();

    const handleDescripcion = (evt) => {
        const nuevoValor = evt.target.value.toUpperCase();
        setNombre(nuevoValor);
    };

    //console.log ('par990=', tipo)

    const handleGuardar = () => {
        if (!nombre) {
            toastCab.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe llenar Nombre' });
            return;
        }
        const formData = {
            codigo: codigoCab,
            nombre: nombre,
            parametro: parametro
        };
        setProcesaGuardar(true);
        onGuardar(formData);
    };

    return (
        <div className="card">
            <h5>Creacion de Cabecera</h5>
            <Toast ref={toastCab} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-4">
                    <label>Codigo Asignado</label>
                </div>
                <div className="field col-12 md:col-8">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">{codigoCab}</span>
                </div>
                <div className="field col-12 md:col-4">
                    <label>Nombre:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <InputText value={nombre} maxLength={100} onInput={handleDescripcion} />
                </div>
                <div className="field col-12 md:col-4">
                    <label>Parametro:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <InputTextarea value={parametro} onChange={(e) => setParametro(e.target.value)} rows={5} cols={30} />
                </div>
                <div className="field col-12 md:col-4">
                    <span>{''}</span>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Guardar" onClick={handleGuardar} loading={procesaGuardar} />
                </div>
                <div className="field col-12 md:col-4">
                    <span>{''}</span>
                </div>
            </div>
        </div>
    );
};

export default CreaCab;
